export default "__VITE_ASSET__C1O5Piqh__"